<div class="myModal">
  <div class="modal-header">
    <button aria-label="Close" (click)="exitModal()" class="close" role="button" aria-label="close">
      <mat-icon aria-hidden="true">close</mat-icon>
    </button>
  </div>
  <div class="modal-body">
    <p *ngIf="mode===1" style="white-space: pre-line">{{ preferenceMessages.modal_partage_content | translate }}</p>
    <p *ngIf="mode===2" style="white-space: pre-line">{{ preferenceMessages.modal_partage_content_bis | translate }}</p>
    <form class="form" [formGroup]="form">
      <app-form-input [parentForm]="form" [label]="preferenceMessages.modal_partage_code | translate" [type]="'text'" [disabled]="mode===1"
      [rule]="'required'" [name]="'code'"></app-form-input>
      <p class="text-danger" *ngIf="wrongCode">{{ preferenceMessages.modal_partage_wrong_code | translate }}</p>
    </form>
  </div>
  <div class="modal-footer">
    <button *ngIf="mode===2" aria-label="confirmer"[disabled]="(!form.valid)" (click)="valider()" class="btn btn-outline-primary" 
      aria-label="confirmer">{{ preferenceMessages.modal_partage_confirmer | translate }}</button>
    <button aria-label="retour" (click)="exitModal()" class="btn btn-outline-primary" 
      aria-label="retour">{{ preferenceMessages.modal_partage_retour | translate }}</button>
  </div>
</div>
